<template>
  <v-flex xs3 px-2 pt-3>
    <alert-description/>

    <alert-toggles/>

    <alert-frequency :margin="margin" :panel-colour="panelColour" v-if="displayFlag" />

    <alert-datasets :margin="margin" :panel-colour="panelColour" v-if="displayFlag" />

    <alert-templates :margin="margin" :panel-colour="panelColour" v-if="displayFlag" />

    <alert-delete-button v-if="displayFlag" :alertId="alert.id"/>
  </v-flex>
</template>
<script>
  import AlertTemplates from './AlertTemplates'
  import AlertFrequency from './AlertFrequency'
  import AlertDatasets from './AlertDatasets'
  import AlertToggles from './AlertToggles'
  import AlertDeleteButton from './AlertDeleteButton'
  import { mapState } from 'vuex'
  import AlertDescription from './alertDescription'

  export default {
    name: 'alert-details-panel',
    components: {AlertDescription, AlertDeleteButton, AlertToggles, AlertTemplates, AlertFrequency, AlertDatasets},
    data () {
      return {
        margin: 'mb-4'
      }
    },
    props: {
      panelColour: {}
    },
    computed: {
      ...mapState({
        alert: state => state.admin.newSingleAlert,
        displayFlag: state => state.admin.alertDetailsDisplayFlag
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertDetailsPanel.vue